import apiClient from "services/apiClient";

async function getCommunitiesMembers(
  search: string,
  organizationIdOrCommunities: number | number[],
  page?: number,
  appName?: string
) {
  const url = "/admin/organizations/communities-members";

  const isCommunityArray = Array.isArray(organizationIdOrCommunities);
  const communityIdsCsv = isCommunityArray
    ? (organizationIdOrCommunities as number[]).join(",")
    : undefined;

  const params = {
    searchString: search,
    page: page ?? 1,
    appName: appName,
    ...(isCommunityArray
      ? { communityIds: communityIdsCsv }
      : { organizationId: organizationIdOrCommunities }),
  };

  const res = await apiClient.get(url, { params });

  return res.data;
}

export default getCommunitiesMembers;
